export default __webpack_public_path__ + "static/media/win.0c0c175f.png";